import React from 'react';

import { Users } from '../../../components/Users/Users';
import { User } from '../../../types/User';

interface Props {
  users: User[];
  limit?: number;
}

export const UsersCell = ({ limit, users }: Props) => {
  return <Users limit={limit} users={users} />;
};
